module.exports = __webpack_public_path__ + "img/SKMJ_limit4.db3aee8c.jpg";